import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage as FormikErrorMessage } from "formik";
import getAccessToken from "../app/services/getAccessToken";
import { setToken, setDealAndToken, getToken } from "../shared/Helpers";
import { useLocation, useNavigate } from "react-router-dom";
import getUser from "../app/services/getUser";
import * as Yup from "yup";
import { removeToken } from "../shared/Helpers";
import Loader from "../components/Loader";
import ReactMarkdown from "react-markdown";
import getCcl from "../app/services/getCcl";
import ErrorMessage from "../components/ErrorMessage";
import rotaGateway from "../app/services/rotaGateway";
import updateUser from "../app/services/updateUser";

function CclSign() {
  const validationSchema = Yup.object({
    acceptTerms: Yup.bool().oneOf(
      [true],
      "You must accept the terms and conditions"
    ),
  });

  const initialValues = {
    acceptTerms: false,
  };
  const navigate = useNavigate();
  const authToken = getToken();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const dealAndToken = queryParams.get("customer");
  const pageParam = queryParams.get("page") || "atj-ccl"; // default page if 'page' param is not provided
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [dealID, setDealID] = useState("");
  const [loginUserData, setLoginUserData] = useState();
  const [data, setData] = useState("");
  const [error, setError] = useState(null);

  const handleError = (error, type, description) => {
    console.error(description, error);
    setError({ error, type, description });
  };

  useEffect(() => {
    const decryptAndFetchToken = async () => {
      if (dealAndToken) {
        try {
          const { data } = await getAccessToken(dealAndToken);
          const userDetails = await getUser(data.token);
          const dealID = userDetails.data.dealID;
          setLoginUserData(userDetails.data);
          setToken(data.token);
          setDealAndToken(dealAndToken);
          setDealID(dealID);
          setIsLoading(false);
        } catch (e) {
          setErrorMessage("User not found");
          setTimeout(() => {
            navigate("/login");
          }, 3000);
        }
      } else {
        removeToken();
        navigate("/login");
      }
    };

    decryptAndFetchToken();
  }, [navigate, dealAndToken]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getCcl(pageParam);
        const attributes = data?.data?.data[0]?.attributes;
        setData(attributes);
      } catch (error) {
        handleError(error, 'load', "Error fetching CCL data");
      }
    };
    fetchData();
  }, [pageParam]);

  const onSubmit = async () => {
    if (dealID) {
      try {
        const cclType = data.CCLType || 'atj-ccl';
        const payload = {
          dealID: dealID,
          cclType: cclType,
          pdFieldTagForValue: data.pdFieldTagForValue || '',
          pdFieldValue: data.pdFieldValue || ''
        };
        await rotaGateway({
          method: 'POST',
          path: 'v1/ccl-complete',
          body: payload,
        });

        // Update CCL Sign In the Strapi
        const updateField = {
            isCCLSigned: true,
            cclSignedOn: new Date().getTime(),
            cclSignedName: data?.Slug || '',
          };
        await updateUser(authToken, updateField);

        navigate("/ccl-completed", {
          state: {
            nextPage: `/ccl-completed`,
            type: "complete",
          },
        });
      } catch (error) {
        handleError(error, 'submit', "Error submitting CCL");
      }
    }
  };

  return (
    <>
      { isLoading && (
        <>
          <p className="text-danger center">{errorMessage}</p>
          <Loader />
        </>
      ) }

      { !isLoading && !error && (
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ isSubmitting }) => (
            <Form>
              <div className="ccl-sign container">
                {data && <h2>{data.title}</h2>}
                {data && <ReactMarkdown>{data.description}</ReactMarkdown>}
                {data && (
                  <div className="terms">
                    <ReactMarkdown>{data.CCL}</ReactMarkdown>
                  </div>
                )}
                {loginUserData.isCCLSigned ?
                  <div className="cclSigned">
                    <p>✅  <strong>Your agreement is confirmed.</strong></p>
                  </div>
                : (
                  <>
                    <div className="form-group">
                      <Field
                        type="checkbox"
                        name="acceptTerms"
                        id="acceptTerms"
                        className="form-check-input"
                      />
                      <label htmlFor="acceptTerms" className="form-check-label">
                        I agree to all the above terms
                        <p>
                          By checking the box, you agree to our terms and we will
                          send you a copy of the agreement.
                        </p>
                      </label>
                      <FormikErrorMessage
                        name="acceptTerms"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={isSubmitting}
                    >
                      Submit
                    </button>
                  </> 
                )}
              </div>
            </Form>
          )}
        </Formik>
      )}
      <ErrorMessage {...error} componentName="CclSign" />
    </>
  );
}

export default CclSign;
